export default __webpack_public_path__ + "assets/moonset.7d3bfe65.svg";